import { defineComponent } from "vue";
const _sfc_main = defineComponent({
  name: "TextFill"
});
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "currentColor",
  viewBox: "0 0 24 24"
};
const _hoisted_2 = /* @__PURE__ */ _createElementVNode("path", {
  "fill-rule": "evenodd",
  d: "M2.99963 19.5H20.9996V22.5H2.99963V19.5ZM19.3121 10.3875C19.4379 10.53 19.5049 10.715 19.4996 10.905V15.75C19.4996 16.1642 19.1638 16.5 18.7496 16.5C18.3354 16.5 17.9996 16.1642 17.9996 15.75V12.6L10.6871 19.305C10.5476 19.4318 10.3656 19.5014 10.1771 19.5H10.1396C9.94112 19.4893 9.75499 19.4003 9.6221 19.2525L3.1946 12.1125C2.91588 11.8077 2.936 11.335 3.2396 11.055L11.2496 3.75V1.5H12.7496V3.15C12.7952 3.17824 12.8379 3.2109 12.8771 3.2475L19.3121 10.3875ZM4.81465 11.655L10.2372 17.655L17.6922 10.845L12.7497 5.3475V9H11.2497V5.7525L4.81465 11.655Z",
  "clip-rule": "evenodd"
}, null, -1);
const _hoisted_3 = [
  _hoisted_2
];
function _sfc_render(_ctx, _cache, $props, $setup, $data, $options) {
  return _openBlock(), _createElementBlock("svg", _hoisted_1, _hoisted_3);
}
import _export_sfc from "/plugin-vue/export-helper";
export default /* @__PURE__ */ _export_sfc(_sfc_main, [["render", _sfc_render], ["__file", "/Users/yimingtian/projects/ym/yimian-ui/packages/icons/src/TextFill.vue"]]);
